import { loadStripe } from "@stripe/stripe-js";

export const STRIPE_MODE = process.env.REACT_APP_STRIPE_MODE;

const publishableKey =
  STRIPE_MODE === "live"
    ? process.env.REACT_APP_STRIPE_LIVE_PUBLIC_KEY
    : process.env.REACT_APP_STRIPE_TEST_PUBLIC_KEY;

export const initStripe = async () => {
  return await loadStripe(publishableKey);
};

export const stripeAction = async (url, showToastAlert) => {
  try {
    if (!url) {
      throw new Error("No checkout URL provided.");
    }
    window.location.href = url;
  } catch (e) {
    console.error(e);
    showToastAlert("error", {
      message: "Something went wrong. Please try again later.",
    });
  }
};
